export const ADD_APPOINTMENTS_TO_STATE = "ADD_APPOINTMENTS_TO_STATE";
export const CLEAR_AND_SET_APPOINTMENTS = "CLEAR_AND_SET_APPOINTMENTS";
export const SET_FETCHED_TIMES = "SET_FETCHED_TIMES";
export const SET_HOSPITAL = "SET_HOSPITAL";
export const DELETE_APPOINTMENT = "DELETE_APPOINTMENT";
export const START_FETCHING = "START_FETCHING";
